import pageInitialiser from './helper/page_initialiser';
import page from '../scripts/_pages/landing_page';
pageInitialiser(page);
